// URL dispatcher for /reception/card/:cardType. Reads the cardType param,
// validates it against the PatientCardType enum, and renders the right
// screen — Family has its own flow (patient_families + beneficiaries);
// everything else reuses PersonalCardScreen with the card type threaded
// through props.

import { Navigate, useParams } from 'react-router-dom';
import type { PatientCardType } from '@pamosi/shared';
import { PATIENT_CARD_TYPES } from '@pamosi/shared';
import { PersonalCardScreen } from './PersonalCardScreen';
import { FamilyCardScreen } from './FamilyCardScreen';

const VALID = new Set<string>(PATIENT_CARD_TYPES);

export function CardTypeRoute() {
    const { cardType } = useParams<{ cardType: string }>();
    if (!cardType || !VALID.has(cardType)) {
        return <Navigate to="/reception" replace />;
    }
    if (cardType === 'family') return <FamilyCardScreen />;
    return <PersonalCardScreen cardType={cardType as PatientCardType} />;
}
